import { MotionProps } from "framer-motion";
import { Difficulty } from "shared/games/Difficulty";
import { State } from "./state/reducer";

export const sideAnimation: MotionProps = {
  transition: { duration: 0.3 },
  initial: { opacity: 1, x: "150%" },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 1, x: "-150%" },
};

export const difficultySettings = {
  compression: ({ difficulty }: State) => {
    if (difficulty === Difficulty.easy) {
      return false;
    }

    return true;
  },

  inGameTrackGrade: ({ difficulty }: State) => {
    if (difficulty === Difficulty.hard) {
      return false;
    }

    return true;
  },
};
